import React, { useContext, useMemo, useState } from 'react';
import EditText from '../crm/shared/field_inputs/text/EditText';
import EditDateTime from '../crm/shared/field_inputs/date/EditDateTime';
import { createGetSuggestionsFromApiUrl } from '../crm/shared/field_inputs/HelpMethods';
import { navigate } from 'hookrouter';
import { HandleAddLecture } from './requests/LectureRequests';
import useDraftEditor from '../../hooks/useDraftEditor';
import ExlEditItemList from './field_inputs/item/ExlEditItemList';
import ExlFormModal from './shared/ExlFormModal';
import ExlEditDraft from './field_inputs/ExlEditDraft';
import { useTranslation } from 'react-i18next';
import { ADD_LECTURE_ADD_NEW_LECTURE_LABEL, EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE, LECTURE_MODALS_DESC_LABEL, LECTURE_MODALS_INVALID_TIME_VALI, LECTURE_MODALS_MEETING_LINK_LABEL, LECTURE_MODALS_NAME_LABEL, LECTURE_MODALS_NO_NAME_VALI, LECTURE_MODALS_NO_TEACHERS_VALI, LECTURE_MODALS_TEACHERS_LABEL } from '../../i18n/keyConstants';
import moment from 'moment';

const AddLecture = ({ parentCourse, open, onClose }) => {

    const defaultFormValues = useMemo(() => ({
        name: parentCourse.name + ' Lektion ' + (parentCourse.lectures.length + 1),
        teachers: parentCourse.teachers,
        meetingLink: parentCourse.meetingLink,
    }), [parentCourse]);

    const { t } = useTranslation(['lectureModals', 'addLecture', 'shared']);

    const {
        editorState,
        setEditorState,
        editorStateToJsonString
    } = useDraftEditor();

    const formComponents = [
        {
            propName: 'name',
            label: t(LECTURE_MODALS_NAME_LABEL),
            validate: (v) => (!v || !v.length ? t(LECTURE_MODALS_NO_NAME_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'description',
            label: t(LECTURE_MODALS_DESC_LABEL),
            component: <ExlEditDraft />
        },
        {
            propName: 'teachers',
            label: t(LECTURE_MODALS_TEACHERS_LABEL),
            validate: (v) => (!v || v.length < 1 ? t(LECTURE_MODALS_NO_TEACHERS_VALI) : ''),
            component:
                <ExlEditItemList
                    iconName='teacher'
                    isClearable
                    getSuggestions={createGetSuggestionsFromApiUrl('/api/exlTeacherFront/getTeacherSuggestions')}

                />
        },
        {
            propName: 'timeRange',
            label: '',
            validate: (v) => (!v ? t(LECTURE_MODALS_INVALID_TIME_VALI) : ''),
            component: <EditDateTime />,
        },
        {
            propName: 'meetingLink',
            label: t(LECTURE_MODALS_MEETING_LINK_LABEL),
            component: <EditText />,
        },
    ];

    const populateLecture = (lecture) => ({
        ...lecture,
        courseId: parentCourse.id,
        startTime: moment(lecture.timeRange.from).utc(),
        endTime: moment(lecture.timeRange.to).utc()
    });

    const handleAdd = async (lecture) => {
        const populatedLecture = populateLecture(lecture);
        const response = await HandleAddLecture(populatedLecture);

        return response;
    };

    return (
        <ExlFormModal
            open={open}
            onClose={onClose}
            description={t(ADD_LECTURE_ADD_NEW_LECTURE_LABEL, { ns: 'addLecture' })}
            defaultFormValues={defaultFormValues}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            onSuccessiveSave={(response) => navigate('/exlLectureDetails/' + response.data.id)}
            isExl
            iconBool={parentCourse.sendEmailNotifications}
            trueText={t(EMAIL_NOTIFICATIONS_TRUE, { ns: 'shared' })}
            falseText={t(EMAIL_NOTIFICATIONS_FALSE, { ns: 'shared' })}
        />
    );
};

export default AddLecture;
